import React from 'react';
import { View } from 'react-native';
import { NestedTabs } from '../../Tabs/rn/NestedTabs';
import { ProductList } from './index';
import { Button } from '../../Button/rn';
import styles from './styles';
export var ProductListTabs = function ProductListTabs(props) {
  var _props$tabs = props.tabs,
    tabs = _props$tabs === void 0 ? [] : _props$tabs,
    userTypeTabs = props.userTypeTabs,
    onLoadMore = props.onLoadMore,
    selectOrderText = props.selectOrderText,
    defaultSelected = props.defaultSelected,
    itemText = props.itemText,
    itemsText = props.itemsText,
    showOrderId = props.showOrderId,
    showUserTypeTab = props.showUserTypeTab,
    _onButtonClick = props.onButtonClick,
    showLoading = props.showLoading,
    tabsType = props.tabsType,
    showStillNotFound = props.showStillNotFound,
    onClickStillNotFound = props.onClickStillNotFound,
    stillNotFoundButtonText = props.stillNotFoundButtonText,
    componentTrackingData = props.componentTrackingData,
    isProductCardNew = props.isProductCardNew,
    watchFn = props.watchFn;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    },
    onLayout: function onLayout(e) {
      var _e$nativeEvent$layout = e.nativeEvent.layout,
        width = _e$nativeEvent$layout.width,
        height = _e$nativeEvent$layout.height;
      watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect("[ProductListTabs] ProductListTabs render, width:".concat(width, " height:").concat(height));
    }
  }, showUserTypeTab && userTypeTabs ? /*#__PURE__*/React.createElement(NestedTabs, {
    type: tabsType,
    userTypeTabs: userTypeTabs,
    defaultSelected: defaultSelected,
    titleContainerStyle: styles.tabsTitleContainer,
    contentStyle: styles.tabsContent,
    componentTrackingData: componentTrackingData,
    renderTab: function renderTab(props) {
      return /*#__PURE__*/React.createElement(ProductList, {
        key: "".concat(props.userType, "-").concat(props.status),
        active: props.userType === props.currentUserType && props.status === props.currentStatus,
        type: props.status,
        userType: props.userType,
        onLoadMore: onLoadMore,
        selectOrderText: selectOrderText,
        itemText: itemText,
        itemsText: itemsText,
        showOrderId: showOrderId,
        onButtonClick: function onButtonClick() {
          for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = arguments[_key];
          }
          _onButtonClick === null || _onButtonClick === void 0 ? void 0 : _onButtonClick.apply(void 0, params);
          watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[ProductList] ProductList btn click');
        },
        showLoading: showLoading,
        componentTrackingData: componentTrackingData,
        isProductCardNew: isProductCardNew,
        watchFn: watchFn
      });
    }
  }) : /*#__PURE__*/React.createElement(NestedTabs, {
    type: tabsType,
    tabs: tabs,
    defaultSelected: defaultSelected,
    titleContainerStyle: styles.tabsTitleContainer,
    contentStyle: styles.tabsContent,
    componentTrackingData: componentTrackingData,
    renderTab: function renderTab(props) {
      return /*#__PURE__*/React.createElement(ProductList, {
        key: props.status,
        active: props.status === props.currentStatus,
        type: props.status,
        onLoadMore: onLoadMore,
        selectOrderText: selectOrderText,
        itemText: itemText,
        itemsText: itemsText,
        showOrderId: showOrderId,
        onButtonClick: function onButtonClick() {
          for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            params[_key2] = arguments[_key2];
          }
          _onButtonClick === null || _onButtonClick === void 0 ? void 0 : _onButtonClick.apply(void 0, params);
          watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[ProductList] ProductList btn click');
        },
        showLoading: showLoading,
        componentTrackingData: componentTrackingData,
        isProductCardNew: isProductCardNew,
        watchFn: watchFn
      });
    }
  }), showStillNotFound && /*#__PURE__*/React.createElement(View, {
    style: styles.notFound
  }, /*#__PURE__*/React.createElement(Button, {
    styles: {
      containerStyle: styles.notFoundButton
    },
    text: stillNotFoundButtonText || 'Still Not Found',
    type: "secondary-outlined",
    onClick: onClickStillNotFound
  })));
};